export default __webpack_public_path__ + "static/media/report_w.885f5779.svg";